import {connect} from 'react-redux';
import ReduxState from '../../types/ReduxState';
import NotificationsClientPlugin, {NotificationsClientPluginProps} from './NotificationsClientPluginWrapper';

const mapStateToProps = (state: ReduxState, {}): Partial<NotificationsClientPluginProps> => {
   return {
      themeName: state.themeName,
      currentUserId: state.currentUser && state.currentUserId
   };
};

export default connect(mapStateToProps, {})(NotificationsClientPlugin);